import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HRGetPRCo_Result } from '@typeDefs/admin/responses/admin';
import { ApiResponse } from '../../../shared/model/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  http = inject(HttpClient);

  getCompanies(): Observable<HRGetPRCo_Result[]> {
    return this.http.get<HRGetPRCo_Result[]>('/Account/GetCompanies');
  }

  kioskLogin(prCo: number, employee: number, password: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Account/KioskLogin', { prCo, employee, password });
  }
}
